import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

export async function AddFetchRol(body) {
  const axiosInstance = await createAxiosInstance();
  const url = ENVIROMENT === "dev" ? `/admon/rol` : `/home/admon/rol`;
  const requestConfig = {
    method: "POST", // Cambia el método si es necesario
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  };
  return axiosInstance(requestConfig);
}
